__webpack_require__.p = "/getting-started-first-time-visited-tooltip/account-setup/";